const textFieldForgotPasswordConfirm = {
  email: 'Su Email',
  password: 'Contraseña',
  helperText: 'Mínimo de 6 caracteres',
  confirmPassword: 'Confirmae su contraseña',
  passwordError: 'Contraseñas diferentes'
};

export default textFieldForgotPasswordConfirm;
